import { Module } from '@nestjs/common';
import { RevenueRegisterService } from './revenue-register.service';
import { RevenueRegisterController } from './revenue-register.controller';
import { ExcelUploadModule } from '../excel-upload/excel-upload.module';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Category } from '../entities/category-entity';
import { SubCategory } from '../entities/sub-category-entity';
import { DrrExcel } from '../excel-upload/entities/drrexcel.entity';
import { LedgerExcel } from '../excel-upload/entities/ledgerexcel.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      Category,
      SubCategory,
      DrrExcel,
      LedgerExcel
    ]),
    ExcelUploadModule
  ],
  providers: [RevenueRegisterService],
  controllers: [RevenueRegisterController]
})
export class RevenueRegisterModule { }
